import UserApi from "@/apis/User.api";
import {getCookie} from "@/helpers/cookie";

const state = {
    user: null,
    accessToken: null,
    examToken: null,
    redirectUrl: null,
    notificationToken: null
};
const getters = {
    user: state => state.user,
    accessToken(state) {
        const accessToken = state.accessToken || getCookie("UserInfo");
        if (accessToken) return accessToken;

        const element = document.getElementById("accessToken");
        if (element) {
            return element.value;
        }
        return null;
    },
    examToken: state => state.examToken,
    redirectUrl: state => state.redirectUrl,
    notificationToken: state => state.notificationToken
};
const mutations = {
    SET_USER: (state, payload) => state.user = payload,
    SET_EXAM_TOKEN: (state, payload) => state.examToken = payload,
    SET_ACCESS_TOKEN: (state, payload) => state.accessToken = payload,
    SET_USER_FULLNAME: (state, payload) => state.user.fullName = payload,
    SET_REDIRECT_URL: (state, payload) => state.redirectUrl = payload,
    SET_NOTIFICATION_TOKEN: (state, payload) => state.notificationToken = payload,
};
const actions = {
    setUser: ({commit}, payload) => commit("SET_USER", payload),
    setExamToken: ({commit}, payload) => commit("SET_EXAM_TOKEN", payload),
    setUserFullName: ({commit}, payload) => commit("SET_USER_FULLNAME", payload),
    signOut: ({commit}) => {
        commit("SET_USER", null);
        commit("SET_ACCESS_TOKEN", null);
        commit("app/SET_WEBSITE", null, {root: true});
        commit("app/SET_MENUS", null, {root: true});
        commit("app/SET_MOOC_MENUS", null, {root: true});
    },
    signIn: async ({commit, dispatch}, type) => {
        dispatch("signOut");
        const form = {
            username: process.env.VUE_APP_USERNAME,
            password: process.env.VUE_APP_PASSWORD,
            idDevice: (Math.random() + 1).toString(36).substring(1),
        }

        if (type === 1) {
            form.username = process.env.VUE_APP_USERNAME2;
            form.password = process.env.VUE_APP_PASSWORD2;
            form.idDevice = (Math.random() + 1).toString(36).substring(1);
        }

        await UserApi.ClearCache({username: form.username});

        const response = await UserApi.SignIn(form);
        if (response.error) return false;
        commit("SET_ACCESS_TOKEN", response.data.accessToken);
        commit("SET_NOTIFICATION_TOKEN", response.data.notificationToken);
        window.localStorage.setItem("ssoToken", response.data.ssoToken);
        return true;
    },
    signInFromAccessToken: async ({commit, dispatch}, payload) => {
        dispatch("signOut");
        const response = await UserApi.LogInFromAccessToken(payload);
        if (response.error) return false;
        commit("SET_ACCESS_TOKEN", response.data.accessToken);
        commit("SET_NOTIFICATION_TOKEN", response.data.notificationToken);
        window.localStorage.setItem("ssoToken", response.data.ssoToken);
        return true;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
